export function resizeImage(url, width = 500, height = 500) {
    if (url?.startsWith('http')) {
        const separate = url?.includes('?') ? "&" : "?"
        return `${url}${separate}height=${height}&width=${width}`
    }
    return url;
}
